import { BillingPayment } from "../../types/payment";

interface PaymentDetailsModalProps {
  open: boolean;
  onClose: () => void;
  payment: BillingPayment | null;
}

export default function PaymentDetailsModal({ open, onClose, payment }: PaymentDetailsModalProps) {
  if (!open || !payment) return null;

  const formatDate = (dateStr: string) => {
    return new Date(dateStr).toLocaleDateString(undefined, {
      year: "numeric",
      month: "long",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50">
      <div className="bg-white rounded-xl shadow-lg w-full max-w-lg p-6">
        {/* Header */}
        <div className="flex items-center justify-between border-b pb-3">
          <h2 className="text-lg font-semibold">Payment Details</h2>
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-gray-600 transition"
          >
            ✕
          </button>
        </div>

        {/* Body */}
        <div className="grid grid-cols-2 gap-4 py-4 text-sm">
          <div>
            <p className="text-gray-500">User</p>
            <p className="font-medium">{payment.username}</p>
          </div>

          <div>
            <p className="text-gray-500">Amount</p>
            <p className="font-medium">
              {payment.amount} {payment.currency}
            </p>
          </div>

          <div>
            <p className="text-gray-500">Product</p>
            <p className="font-medium">{payment.product}</p>
          </div>

          <div>
            <p className="text-gray-500">Service</p>
            <p className="font-medium">{payment.service_name ?? "—"}</p>
          </div>

          <div>
            <p className="text-gray-500">Gateway</p>
            <p className="font-medium">{payment.payment_gateway ?? "—"}</p>
          </div>

          <div>
            <p className="text-gray-500">Mobile Operator</p>
            <p className="font-medium">{payment.mobile_operator ?? "—"}</p>
          </div>

          <div>
            <p className="text-gray-500">Status</p>
            <span
              className={`px-2 py-1 rounded text-xs font-semibold ${
                payment.status === "successful"
                  ? "bg-green-100 text-green-700"
                  : payment.status === "failed"
                  ? "bg-red-100 text-red-700"
                  : "bg-gray-100 text-gray-600"
              }`}
            >
              {payment.status}
            </span>
          </div>

          <div>
            <p className="text-gray-500">Date</p>
            <p className="font-medium">{formatDate(payment.created_at)}</p>
          </div>
        </div>

        {/* Failure reason (highlighted) */}
        {payment.failure_reason && (
          <div className="mt-4 p-3 rounded-lg bg-red-50 border border-red-200">
            <p className="text-sm font-semibold text-red-700">Failure Reason</p>
            <p className="text-sm text-red-600">{payment.failure_reason}</p>
          </div>
        )}

        {/* Footer */}
        <div className="flex justify-end pt-4 border-t mt-4">
          <button
            onClick={onClose}
            className="px-4 py-2 bg-gray-100 hover:bg-gray-200 rounded-lg text-sm font-medium transition"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
}
